import { getCourseNavigationLinks, handleCanvasLinksAPI } from '../../../middleware/api';

/* eslint-disable @typescript-eslint/no-explicit-any */
const setSortingElement = (optionValues: any) => {
  switch (optionValues) {
    case 'Files':
      return 'display_name';
    case 'Assignments':
      return 'name';
    case 'Pages':
    case 'Discussions':
      return 'title';
    default:
      return optionValues;
  }
};

const setQueryparam = (
  sortingTypeCheck: string,
  optionValue: string,
  courseFilter: string | any[],
  index: number,
) => {
  let announcement;
  let setFilter = '';
  if (optionValue === 'Announcements') {
    announcement =
      !courseFilter?.length || sortingTypeCheck === 'recent'
        ? `only_announcements=false`
        : `only_announcements=true`;
  }
  setFilter = courseFilter?.length >= 2 ? `&search_term=${courseFilter}` : '';
  switch (optionValue) {
    case 'Modules':
      return `page=${index}&per_page=100${setFilter}`;
    case 'Pages':
    case 'Files':
      return `page=${index}&per_page=100${setFilter}${
        sortingTypeCheck !== 'recent'
          ? `&order=${sortingTypeCheck}&sort=${setSortingElement(optionValue)}`
          : `&sort=updated_at&order=desc`
      }`;
    case 'Announcements':
      return `page=${index}&per_page=100&${announcement}${setFilter}${
        sortingTypeCheck !== 'recent' ? `&order_by=title` : '&order_by=recent_activity'
      }`;
    case 'Assignments':
      return `page=${index}&per_page=100${setFilter}&order_by=name`;
    case 'Discussions':
      return `page=${index}&per_page=100${setFilter}${
        sortingTypeCheck !== 'recent' ? `&order_by=title` : `&order_by=recent_activity`
      }`;
    case 'Quizzes':
      return `page=${index}&per_page=100${setFilter}`;
  }
};

export const handlingQuicklinks = async (
  linksType: string,
  sortingType: string,
  searchValue: string,
  pageNum: number,
  env: string,
  courseId: string,
  signal?: AbortSignal,
) => {
  try {
    const option =
      linksType === 'Discussions' || linksType === 'Announcements'
        ? 'discussion_topics'
        : linksType;
    switch (linksType) {
      case 'Modules':
      case 'Pages':
      case 'Assignments':
      case 'Discussions':
      case 'Quizzes':
      case 'Announcements':
      case 'Files':
        return await handleCanvasLinksAPI(
          option,
          env,
          courseId,
          setQueryparam(sortingType, linksType, encodeURIComponent(searchValue), pageNum) as string,
          signal,
        );
      case 'Course Navigation':
        return await getCourseNavigationLinks(courseId, pageNum, env, signal);
      default:
        return [];
    }
  } catch (err) {
    console.log(`error in fetching in canvas ${linksType} data`, err);
  }
};
